import MultiPlatformText from '@/components/ui/MultiPlatformText';
import { getBackgroundStyles } from '@/lib/sanity/utils';
import type { Banner } from '@/types/sanity/content';
import clsx from 'clsx';

interface BannerProps {
  banner: Banner;
  className?: string;
}

export default function Banner({ banner, className }: BannerProps) {
  const { text, background } = banner;

  const backgroundStyles = getBackgroundStyles(background);

  return (
    <div className={clsx('w-full', className)}>
      <div className="flex items-center justify-center gap-4 py-1 md:py-3" style={backgroundStyles}>
        <div className="text-center text-sm text-white md:text-base">
          <MultiPlatformText content={text} />
        </div>
      </div>
    </div>
  );
}
